import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createSlots as _createSlots } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 全选 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 清空 ")

import { Nullable, SimpleItem } from '@velites/common';
import { useAttrs } from 'element-plus';



export default /*#__PURE__*/_defineComponent({
  props: {
  options: {
    type: Array as () => Array<SimpleItem>,
    default: () => [],
  },
  modelValue: {
    type: String,
  },
  hasAll: {
    type: Boolean,
    default: false,
  },
  allLabel: {
    type: String,
    default: '全部',
  },
},
  emits: ["update:model-value"],
  setup(__props, { emit }: { emit: ((event: 'update:model-value', value: Nullable<string>) => void), expose: any, slots: any, attrs: any }) {

const props = __props



const attrs = useAttrs();
const update = (value: string) => {
  emit('update:model-value', value || undefined);
};
const selectAll = () => {
  update(props.options.map((it) => it.value) as any);
};
const clear = () => {
  emit('update:model-value', undefined);
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, _mergeProps(_unref(attrs), {
    "model-value": __props.modelValue,
    "onUpdate:modelValue": update
  }), _createSlots({
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((__props.hasAll
        ? [{ label: __props.allLabel, value: undefined }]
        : []
      ).concat(__props.options), (item) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          key: item.value,
          value: item.value,
          label: item.label
        }, null, 8, ["value", "label"]))
      }), 128))
    ]),
    _: 2
  }, [
    (_unref(attrs).multiple === '' || _unref(attrs).multiple === true)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createVNode(_component_el_button, {
              text: "",
              bg: "",
              size: "small",
              onClick: selectAll
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              text: "",
              bg: "",
              size: "small",
              onClick: clear
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ])
        }
      : undefined
  ]), 1040, ["model-value"]))
}
}

})